import FamilyTree from './source';

const NODE_WIDTH = 120;
const NODE_HEIGHT = 180;
const NODE_RADIUS = 5;

const IMG_X = 5;
const IMG_Y = 5;
const IMG_WIDTH = 110;
const IMG_HEIGHT = 110;
const IMG_RADIUS = 5;

const COLOR_STROKE = '#aeaeae';
const COLOR_PRIMARY = '#27326C';
const COLOR_ANCESTRY = '#94bf13';
const COLOR_MALE = '#c8dae5';
const COLOR_FEMALE = '#edc3b2';
const COLOR_MALE_ICON = '#7eacc0';
const COLOR_FEMALE_ICON = '#cf6e53';
const COLOR_UNKNOWN = '#eeeeee';

FamilyTree.templates.custom = Object.assign({}, FamilyTree.templates.hugo);
FamilyTree.templates.custom.size = [NODE_WIDTH, NODE_HEIGHT];
FamilyTree.templates.custom.node = `<rect width="${NODE_WIDTH}" height="${NODE_HEIGHT}" rx="${NODE_RADIUS}" fill="${COLOR_UNKNOWN}" stroke-width="1" stroke="${COLOR_STROKE}"></rect>`;

FamilyTree.templates.custom.defs = `
<symbol id="btn_plus" viewBox="-1 -1 34 34" style="cursor: pointer;">
<circle cx="16" cy="16" r="16" fill="#fff" stroke="${COLOR_STROKE}" stroke-width="1"></circle>
<path d="M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z" fill="${COLOR_PRIMARY}"/>
<path d="M16,23a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0V22A1,1,0,0,1,16,23Z" fill="${COLOR_PRIMARY}"/>
<path d="M22,17H10a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z" fill="${COLOR_PRIMARY}"/>
</symbol>

<symbol id="btn_cancel" viewBox="-1 -1 34 34" style="cursor: pointer;">
<circle cx="16" cy="16" r="16" fill="#fff" stroke="${COLOR_STROKE}" stroke-width="1"></circle>
<path d="M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z" fill="${COLOR_PRIMARY}"/>
<path d="M11.76,21.24a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.41l8.49-8.49A1,1,0,0,1,21,12.46L12.46,21A1,1,0,0,1,11.76,21.24Z" fill="${COLOR_PRIMARY}"/>
<path d="M20.24,21.24a1,1,0,0,1-.7-.29l-8.49-8.49a1,1,0,0,1,1.41-1.41L21,19.54A1,1,0,0,1,21,21,1,1,0,0,1,20.24,21.24Z" fill="${COLOR_PRIMARY}"/>
</symbol>

<symbol id="btn_menu" style="cursor: pointer;">
<rect x="0" y="0" width="16" height="16" fill="transparent"></rect>
<path d="M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z" fill="${COLOR_PRIMARY}"/>
<path d="M4 8C4 9.10457 3.10457 10 2 10C0.895431 10 0 9.10457 0 8C0 6.89543 0.895431 6 2 6C3.10457 6 4 6.89543 4 8Z" fill="${COLOR_PRIMARY}"/>
<path d="M16 8C16 9.10457 15.1046 10 14 10C12.8954 10 12 9.10457 12 8C12 6.89543 12.8954 6 14 6C15.1046 6 16 6.89543 16 8Z" fill="${COLOR_PRIMARY}"/>
</symbol>

<symbol id="btn_up" viewBox="-1 -1 34 34" style="cursor: pointer;">
<circle cx="16" cy="16" r="16" fill="#fff" stroke="${COLOR_STROKE}" stroke-width="1"></circle>
${FamilyTree.icon.ft(22, 22, COLOR_ANCESTRY, 5, 5)}
</symbol>
`;

FamilyTree.templates.custom.ripple = {
  radius: 0,
  color: 'none',
  rect: null,
};

FamilyTree.templates.custom.img_0 = `<clipPath id="ulaImg">
  <rect x="${IMG_X}" y="${IMG_Y}" width="${IMG_WIDTH}" height="${IMG_HEIGHT}" rx="${IMG_RADIUS}"></rect>
  </clipPath>
  <image preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="${IMG_X}" y="${IMG_Y}" width="${IMG_WIDTH}" height="${IMG_HEIGHT}" />`;
FamilyTree.templates.custom.field_0 =
  '<text style="font-size: 13px; font-weight:bold;" fill="#000000" x="60" y="135" text-anchor="middle">{val}</text>';
FamilyTree.templates.custom.field_1 =
  '<text style="font-size: 13px; font-weight:bold;" fill="#000000" x="60" y="150" text-anchor="middle">{val}</text>';
FamilyTree.templates.custom.field_2 =
  '<text style="font-size: 12px;" fill="#000000" x="60" y="170" text-anchor="middle">{val}</text>';

FamilyTree.templates.custom.nodeMenuButton =
  '<use style="cursor:pointer;" data-ctrl-n-menu-id="{id}" x="100" y="130" xlink:href="#btn_menu" />';

FamilyTree.templates.custom.menuButton =
  '<div style="position:absolute;right:{p}px;top:{p}px; width:40px;height:50px;cursor:pointer;" data-ctrl-menu="">' +
  '<hr style="background-color: rgb(255, 202, 40); height: 3px; border: none;">' +
  '<hr style="background-color: rgb(255, 202, 40); height: 3px; border: none;">' +
  '<hr style="background-color: rgb(255, 202, 40); height: 3px; border: none;">' +
  '</div>';

// FamilyTree.templates.custom.pointer = `<g data-pointer="pointer" transform="matrix(0,0,0,0,100,100)"><g transform="matrix(0.3,0,0,0.3,-17,-17)">
//   <polygon fill="${COLOR_PRIMARY}" points="53.004,173.004 53.004,66.996 0,120" />
//   <polygon fill="${COLOR_PRIMARY}" points="186.996,66.996 186.996,173.004 240,120" />
//   <polygon fill="${COLOR_PRIMARY}" points="66.996,53.004 173.004,53.004 120,0" />
//   <polygon fill="${COLOR_PRIMARY}" points="120,240 173.004,186.996 66.996,186.996" />
//   <circle fill="${COLOR_PRIMARY}" cx="120" cy="120" r="30" />
//   </g></g>`;

// FamilyTree.templates.custom.link =
//   '<path stroke="#686868" stroke-width="1px" fill="none" data-l-id="[{id}][{child-id}]" d="M{xa},{ya} C{xb},{yb} {xc},{yc} {xd},{yd}" />';

FamilyTree.templates.custom.up =
  '<use x="48" y="-12" width="24" height="24" xlink:href="#btn_up" />';
FamilyTree.templates.custom.nodeTreeMenuButton =
  '<use data-ctrl-n-t-menu-id="{id}" x="108" y="-12" width="24" height="24" xlink:href="#btn_plus"/>';
FamilyTree.templates.custom.nodeTreeMenuCloseButton =
  '<use data-ctrl-n-t-menu-c="" x="108" y="-12" width="24" height="24" xlink:href="#btn_cancel" />';

FamilyTree.templates.custom_male = Object.assign({}, FamilyTree.templates.custom);
FamilyTree.templates.custom_male.node = `<rect width="${NODE_WIDTH}" height="${NODE_HEIGHT}" rx="${NODE_RADIUS}" fill="${COLOR_MALE}" stroke-width="1" stroke="${COLOR_STROKE}"></rect>`;
FamilyTree.templates.custom_female = Object.assign({}, FamilyTree.templates.custom);
FamilyTree.templates.custom_female.node = `<rect width="${NODE_WIDTH}" height="${NODE_HEIGHT}" rx="${NODE_RADIUS}" fill="${COLOR_FEMALE}" stroke-width="1" stroke="${COLOR_STROKE}"></rect>`;

const addNewPersonNode = (label, color, icon) => ({
  node: `<rect x="0" y="0" height="{h}" width="{w}" style="fill:transparent;" stroke-width="1" stroke="${color}" rx="${NODE_RADIUS}"></rect>
    <text style="font-size: 13px; font-weight: bold;" fill="#000" x="60" y="135" text-anchor="middle">${label}</text>${icon}`,
});

FamilyTree.templates.mother = Object.assign(
  {},
  FamilyTree.templates.custom,
  addNewPersonNode(
    'Add Mother',
    COLOR_FEMALE_ICON,
    FamilyTree.icon.mother(60, 60, COLOR_FEMALE_ICON, 30, 40),
  ),
);

FamilyTree.templates.father = Object.assign(
  {},
  FamilyTree.templates.mother,
  addNewPersonNode(
    'Add Father',
    COLOR_MALE_ICON,
    FamilyTree.icon.father(60, 60, COLOR_MALE_ICON, 30, 40),
  ),
);

FamilyTree.templates.partner = Object.assign(
  {},
  FamilyTree.templates.mother,
  addNewPersonNode('Add Partner', COLOR_PRIMARY),
);

FamilyTree.templates.husband = Object.assign(
  {},
  FamilyTree.templates.mother,
  addNewPersonNode(
    'Add Husband',
    COLOR_MALE_ICON,
    FamilyTree.icon.husband(60, 60, COLOR_MALE_ICON, 30, 40),
  ),
);

FamilyTree.templates.wife = Object.assign(
  {},
  FamilyTree.templates.mother,
  addNewPersonNode(
    'Add Wife',
    COLOR_FEMALE_ICON,
    FamilyTree.icon.wife(60, 60, COLOR_FEMALE_ICON, 30, 40),
  ),
);

FamilyTree.templates.daughter = Object.assign(
  {},
  FamilyTree.templates.mother,
  addNewPersonNode(
    'Add Daughter',
    COLOR_FEMALE_ICON,
    FamilyTree.icon.daughter(60, 60, COLOR_FEMALE_ICON, 30, 40),
  ),
);

FamilyTree.templates.son = Object.assign(
  {},
  FamilyTree.templates.mother,
  addNewPersonNode(
    'Add Son',
    COLOR_MALE_ICON,
    FamilyTree.icon.son(60, 60, COLOR_MALE_ICON, 30, 40),
  ),
);

export default FamilyTree;
